import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { dateFormat, SearchArchiveItems, ToastService } from '../../core';
import { ArchiveService } from '../../services';
import { AnatomicalSideLabelPipe, BaseComponent, BoneTypeLabelPipe, ConvertDatePipe, PlanTypeLabelPipe } from '../../shared';
import { ArchivePaginationComponent } from '../archive-pagination';


/**
* Archive table component.
*/
@Component({
	selector: 'archive-table',
	templateUrl: './archive-table.component.html',
	imports: [
		ConvertDatePipe,
		PlanTypeLabelPipe,
		BoneTypeLabelPipe,
		AnatomicalSideLabelPipe,
		ArchivePaginationComponent
	],
	changeDetection: ChangeDetectionStrategy.Eager
})
export class ArchiveTableComponent extends BaseComponent implements OnInit, OnDestroy {

	private readonly toastSrv = inject(ToastService);
	private readonly archiveSrv = inject(ArchiveService);

	collectionSize: number = 0;
	list: SearchArchiveItems[] = [];

	readonly dateFormat = dateFormat();
	private _searchResultSub$?: Subscription;


	ngOnInit(): void {
		this._searchResultSub$ = this.archiveSrv.getSearchResult().subscribe(list => {
			this.collectionSize = list ? list.count : 0;
			this.list = list ? list.items : [];
		});
		this.archiveSrv.search();
	}

	/**
	 * Open view plan in other tab.
	 */
	viewCase(id: string): void {
		this.archiveSrv.getViewCase(id).subscribe({
			next: url => window.open(url, '_blank'),
			error: () => this.toastSrv.showError(this.labels().ARCHIVE_TABLE_COMPONENT_LOAD_ERROR)
		});
	}

	/**
	 * Open image in other tab.
	 */
	viewImage(id: string): void {
		this.archiveSrv.getImage(id).subscribe({
			next: url => window.open(url, '_blank'),
			error: () => this.toastSrv.showError(this.labels().ARCHIVE_TABLE_COMPONENT_LOAD_ERROR)
		});
	}


	ngOnDestroy(): void {
		this._searchResultSub$?.unsubscribe();
		this.archiveSrv.resetSearchResult();
	}

}
